import { useEffect, useState, useRef } from "react";
import momentumailoading from "../assets/images/Support-Bot/momentum-ai-loading.gif";
import { Guid } from "js-guid";
import AccessDenied from "../assets/images/not-allowed-symbol.svg";
import axios from "axios";
import CommonValues from "../common/utils";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import AtkLoader from "../AtlaskitControls/AtkLoader";
import BackgroundVideo from "../common/BackgroundVideo";
import Header from "../common/Header";
import NcLogo from "../assets/images/momemntumpurple.webp";

export default function BridgeValidation() {
  const [loading, setLoading] = useState(true);
  const toast: any = useRef("");
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  const trackClickForGenerateQuote = searchParams.get("trackClickForGenerateQuote");
  const widgetName = searchParams.get("widget");
  const policyid = searchParams.get("policyid");
  const embeded = searchParams.get("embeded");
  const hostname = window.location.hostname;
  useEffect(() => {
    if (
      hostname !== process.env.REACT_APP_Momentum_Url1 &&
      hostname !== process.env.REACT_APP_Momentum_Url2 &&
      hostname !== process.env.REACT_APP_Momentum_Url3 &&
      hostname !== process.env.REACT_APP_Momentum_Url4
    ) {
      navigate("/not-allowed");
    }
  }, [hostname, navigate]);
  useEffect(() => {
    CommonValues.ClearAllValues();
    validateToolboxToken();
  }, []);

  const validateToolboxToken = () => {
    setLoading(true);
    var token: any = searchParams.get("token");
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_AUTHAPI}/api/account/validatetoolboxtoken?token=${token}`,
      headers: {}
    };

    axios.request(config)
      .then((response: any) => {

        CommonValues.SetValues(
          response.data.token,
          response.data.tenantId,
          response.data.userName,
          response.data.userId,
          response.data.companyName,
          response.data.roleId,
          response.data.avatarName,
          response.data.firstName,
          "",
          response.data.iconURL,
          response.data.hasGIGMarket,
          response.data.slugURL,
          response.data.headerText
        );
        getMomentumToken();
      })
      .catch((error: any) => {
        setLoading(false);
        toast.current.show({
          severity: "info",
          detail:
            "Unknown error occured while validating the token.",
          life: 3000,
        });
      });
  };
  const getMomentumToken = () => {
    const token = CommonValues.GetToken();
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_UserService_Url}/api/user/getmomentumtoken`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.data !== "" || response.data !== null) {
          localStorage.setItem("NCToken", response.data.access_token);
          localStorage.setItem("NCAgencyId", response.data.agencyId);
          getCommonSettings();
        }
      })
      .catch((error) => {

        setLoading(false);
        if (error.response !== null) {
          if (error.response.status === 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else {
            if (toast.current) {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Unknown error while loading the NowCerts Setting details",
                life: 3000,
              });
            }
          }
        } else {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while loading the NowCerts Setting details",
              life: 3000,
            });
          }
        }
      });
  };
  const getCommonSettings = () => {
    var token = CommonValues.GetToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_UserService_Url}/api/user/pfcommonsettings`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then((response: any) => {
        localStorage.setItem("tenantId", response.data.pfTenantId);
        localStorage.setItem("clientCount", response.data.clientCount);
        localStorage.setItem("HawksoftSettings", JSON.stringify(response.data));
        navigate("/premiumfinance", { state: { widgetName, policyid } });
        setLoading(false);
      })
      .catch((error: any) => {        
        setLoading(false);
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status == 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else {
            errorMessage = "Unknown error while loading the Setting details";
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: { errorMessage },
              life: 3000,
            });
          }
        } else {
          errorMessage = "Unknown error while loading the Setting details";
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: { errorMessage },
            life: 3000,
          });
        }
      });
  };
  return (
    <div className="momentum-sso-page">
      <Toast ref={toast} />
      {embeded === "true" ? null : <Header pagename="momentum-sso-page" />}
      <div className="content-wrapper container-fluid landing-content-wrapper d-flex justify-content-center">
        <BackgroundVideo />
        <div className="login-box ">
          <div className="row mx-auto d-flex align-items-center">
            <div className="col-12 text-center  nowcerts-loader">
              {loading ? (
                <>
                  <div className=" authenticating-block-pf text-center">
                    {widgetName == "momentumai" ? <h2>Momentum AI</h2> : <img src={NcLogo} height="60px" />}
                    <div className="mt-3 mb-3">
                      <span className="">Authenticating</span>
                    </div>
                    <div className="d-flex justify-content-center nowcerts-sso-loader">
                      <AtkLoader />
                    </div>
                  </div>
                </>
              ) : (
                <div className=" d-flex align-items-center justify-content-center" style={{ minHeight: "100px" }}>
                  <span className="not-authorize-text">You are not authorized</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}